export default "__VITE_ASSET__Bb1ke2km__"